import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  OCEAN: 'ocean',
  NEON: 'neon'
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('flexigym_theme') || THEMES.LIGHT;
  });

  const [accentColor, setAccentColor] = useState(() => {
    try {
      const storedUser = localStorage.getItem('flexigym_user');
      if (storedUser) {
        const u = JSON.parse(storedUser);
        if (u?.gym_id) {
          const gymColor = localStorage.getItem(`gym_accent_color_${u.gym_id}`);
          if (gymColor) return gymColor;
        }
      }
    } catch (e) {}
    return '#f97316'; // Default Orange
  });

  const [timezone, setTimezone] = useState(() => {
    return localStorage.getItem('flexigym_timezone') || 'Asia/Kolkata'; // Default IST
  });

  useEffect(() => {
    localStorage.setItem('flexigym_theme', theme);
    document.documentElement.classList.remove('theme-light', 'theme-dark', 'theme-ocean', 'theme-neon');
    document.documentElement.classList.add(`theme-${theme}`);

    if (theme === THEMES.DARK) {
      document.body.style.backgroundColor = '#0f172a';
      document.body.style.color = '#f8fafc';
    } else if (theme === THEMES.OCEAN) {
      document.body.style.backgroundColor = '#082f49';
      document.body.style.color = '#f0f9ff';
    } else if (theme === THEMES.NEON) {
      document.body.style.backgroundColor = '#18181b';
      document.body.style.color = '#fafafa';
    } else {
      document.body.style.backgroundColor = '#f9fafb';
      document.body.style.color = '#111827';
    }
  }, [theme]);

  useEffect(() => {
    document.documentElement.style.setProperty('--accent-color', accentColor);
  }, [accentColor]);

  useEffect(() => {
    localStorage.setItem('flexigym_timezone', timezone);
  }, [timezone]);

  const changeTheme = (newTheme) => {
    setTheme(newTheme);
  };

  const changeAccentColor = (newColor, gymId) => {
    setAccentColor(newColor);
    document.documentElement.style.setProperty('--accent-color', newColor);

    let targetGymId = gymId;
    if (!targetGymId) {
      try {
        const storedUser = localStorage.getItem('flexigym_user');
        if (storedUser) {
          const u = JSON.parse(storedUser);
          targetGymId = u?.gym_id;
        }
      } catch (e) {}
    }
    if (targetGymId) {
      localStorage.setItem(`gym_accent_color_${targetGymId}`, newColor);
    }
  };

  const resetAccentColor = () => {
    setAccentColor('#f97316');
    document.documentElement.style.setProperty('--accent-color', '#f97316');
  };

  const changeTimezone = (newTimezone) => {
    setTimezone(newTimezone);
  };

  return (
    <ThemeContext.Provider value={{
      theme,
      changeTheme,
      accentColor,
      changeAccentColor,
      resetAccentColor,
      timezone,
      changeTimezone,
      THEMES
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
